import clsx from 'clsx';
import React from 'react';

type StatCardProps = {
  header: string;
  mainText: string;
  secondaryText?: string;
  description?: string;
  className?: string;
  loading?: boolean;
};

export const StatCard: React.FC<StatCardProps> = ({
  header,
  mainText,
  secondaryText,
  description,
  className,
  loading = false,
}) => {
  return (
    <div
      className={clsx(
        'w-full bg-gray-50 rounded-3xl p-6 lg:p-8',
        'flex flex-col justify-between gap-4',
        'min-h-[220px] lg:min-h-[280px]',
        'text-black font-[var(--ep-font-avenir)]',
        className
      )}
    >
      <div className="text-center text-lg lg:text-2xl font-medium">{header}</div>

      <div className="flex-1 flex flex-col justify-center items-center">
        <div className={clsx('text-center font-medium text-3xl', !secondaryText && 'lg:text-5xl')}>
          {loading ? 'Loading...' : mainText}
        </div>
        {!loading && secondaryText && (
          <>
            <div className="w-2/3 border-t border-gray-300 my-4" />
            <div className="text-center text-sm font-medium">{secondaryText}</div>
          </>
        )}
      </div>

      {description && <div className="text-center text-xs lg:text-sm font-medium">{description}</div>}
    </div>
  );
};
